<template>
	<div v-if="uploads.length > 0 ? true: false">
		<div style="margin: 5px; padding: 5px;" v-for="(upload, idx) in uploads" class="email" :key="upload._id">
			<b style='color:purple;font-size:16px'>File: {{ upload.originalFileName }}</b><br />
			<b>On:</b> {{ new Date(upload.when).toLocaleDateString() }} {{ new Date(upload.when).toLocaleTimeString() }},
			<b>Total:</b> {{ upload.totalCount }},
			<b>Updated:</b> {{ upload.successCount }},
			<b>Rejected:</b> {{ upload.rejectCount }},
			<b>Deleted:</b> {{ upload.deleteCount }}<br />
			<button @click="toggleChanges(idx)">
				{{ isChangesVisible(idx) ? 'Close Changes' : 'Show Changes' }}
			</button>
			<transition name="expand">
				<div v-if="upload.fileLog && isChangesVisible(idx)" class="changes-container">
					<!-- Pagination Info -->
					<div v-if="getTotalChanges(idx) > 0" class="pagination-info">
					<span class="pagination-summary">
						Showing {{ getDisplayStart(idx) }}-{{ getDisplayEnd(idx) }} of {{ getTotalChanges(idx) }} resources
					</span>
					<div class="items-per-page-selector" v-if="showPagination(idx)">
						<label>Items per page:</label>
						<select v-model="paginationSettings[idx].itemsPerPage" @change="handleItemsPerPageChange(idx)">
							<option v-for="option in paginationOptions" :key="option" :value="option">
								{{ option }}
							</option>
						</select>
					</div>
				</div>

				<!-- Paginated Resources List -->
				<div v-for="(res, i) in getPaginatedChanges(idx)" :key="`resource:${i}:${res.fileNumber}`">
					<div>
						<span style="color:green;font-weight:600;" v-if="res.success"> {{res.fileNumber}} {{ res.resourceName ?  res.resourceName: "Unknown"  }} </span>
						<span style="color:red;font-weight:600;" v-if="!res.success"> {{res.fileNumber}} {{ res.resourceName ?  res.resourceName: "Unknown" }} - (Reason:: {{res.message}}) </span>
					</div>
				</div>

				<!-- Pagination Controls -->
				<div v-if="showPagination(idx)" class="pagination-controls">
					<paginate
						v-model="paginationSettings[idx].currentPage"
						:page-count="getTotalPages(idx)"
						:page-range="3"
						:margin-pages="2"
						:click-handler="(pageNum) => handlePageChange(idx, pageNum)"
						:prev-text="'Prev'"
						:next-text="'Next'"
						:container-class="'pagination'"
						:page-class="'page-item'"
					/>
				</div>
				</div>
			</transition>
		</div>
	</div>
	<div v-else >
		<div style="margin: 10px 0px">
			<span>No resource files have been uploaded yet..</span>
		</div>
	</div>
</template>
<!-- Script-->
<script>
import API from "../services/API";
import Paginate from "vuejs-paginate";
import Vue from "vue";
import paginatedUploadsMixin from "../mixins/paginatedUploadsMixin";

Vue.component("paginate", Paginate);

export default {
	name: "RecentResourceUploads",
	components: {
		Paginate
	},
	mixins: [paginatedUploadsMixin],
	props: ["community_id"],
	data() {
		return {
			api: new API(),
			uploads: [],
			logKey: "fileLog",
			visibleChanges: {}
		};
	},
	watch: {
		"community_id": "loadData"
	},
	mounted() {
		this.loadData();
	},
	methods: {
		loadData: function () {
			if (this.community_id) {
				this.api.get(`communities/${this.community_id}/recent-resource-uploads`).then(uploads => {
					this.uploads = uploads.data;
					this.initializePaginationSettings();
				});
			}
		},
		getFullDetails: function (idx) {
			this.api.get(`communities/${this.community_id}/recent-resource-uploads/${this.uploads[idx]._id}`).then(upload => {
				this.uploads[idx] = upload.data;
				this.$forceUpdate();
				this.initializePaginationForUpload(idx);
			});
		},

		toggleChanges(idx) {
			if (!this.uploads[idx].fileLog) {
				// Si no hay datos cargados, cargarlos primero y mostrarlos
				this.getFullDetails(idx);
				this.$set(this.visibleChanges, idx, true);
			} else {
				// Toggle la visibilidad
				this.$set(this.visibleChanges, idx, !this.visibleChanges[idx]);
			}
		},

		isChangesVisible(idx) {
			return this.visibleChanges[idx] || false;
		}
	}
};
</script>

<style scoped>
  @import "../styles/pagination.css";
</style>



// WEBPACK FOOTER //
// src/components/RecentResourceUploads.vue